import { Component, ElementRef, HostListener, OnInit, ViewChild, ChangeDetectorRef } from "@angular/core";
import { ProductService } from "src/app/components/shared/services/product.service";
import { Router } from "@angular/router";
import { ColorFilter } from "src/app/modals/product.model";
import { FormGroup } from "@angular/forms";
import { ConfigService } from "src/app/components/shared/services/config.service";
import { DSProduct } from "src/app/modals/dsproduct.modal";
import { UtilityService } from "src/app/components/shared/services/utility.service";
import { TranslateService } from "@ngx-translate/core";
import { Title } from "@angular/platform-browser";
import * as _ from "lodash";
import { ItemsListService } from "src/app/components/shared/services/itemsList.service";
import { CompanyService } from "src/app/components/shared/services/company.service";
import { Cart1Service } from "src/app/components/shared/services/cart1.service";
import { environment } from "src/environments/environment";
import { MatDialog } from "@angular/material/dialog";
import { DialogforproductComponent } from "../../shared/dialogforproduct/dialogforproduct.component";
import { LoaderService } from "../../shared/services/loader.service";
import { UserService } from "../../shared/services/user.service";
import { RestApiService } from "../../shared/services/restapi.service";
import { CORPORATESTOREID, RETAILSTOREID, DefaultRegionID, REWARDSTORE } from "src/app/constant";

@Component({
  selector: "app-rewards",
  templateUrl: "./rewards.component.html",
  styleUrls: ["./rewards.component.scss"],
})
export class RewardsComponent implements OnInit {
  variableBrowse = false;
  public product: any = {};
  displayProductList: any[] = [];
  displayForCarousel = [
    {
      img: "../../../../assets/images/new/banner-4.jpg",
      startext:
        "Super products, especially now when we need to keep our immune system strong!",
      author: "Dr. Karl Anderson",
      location: "Meridian, ID",
      small: false,
      medium: true,
      left: false,
      leftbig: true,
      boxTitle: "QUALITY PRODUCTS",
      boxContent: "All Natural Ingredients for Your Health Goals",
    },
  ];
  env: any;
  searchFormGroup: FormGroup;
  categoryTypeGroup: FormGroup;
  sortByFormGroup: FormGroup;
  productSearchText: string = "";
  public sidenavOpen: boolean = true;
  public animation: any; // Animation
  public sortByOrder: any; // sorting
  public page: any;
  public tagsFilters: any[] = [];
  public viewType: string = "grid";
  public viewCol: number = 34;
  public filterForm: FormGroup;
  public colorFilters: ColorFilter[] = [];
  public searchProduct: any;
  public items: Array<DSProduct> = [];
  public products: Array<DSProduct> = [];
  public CustomMadeItemArray: Array<DSProduct> = [];
  public allItems: { Category: any; CategoryId: any }[] = [];
  public featuredCollection: Array<DSProduct> = [];
  public tags: any[] = [];
  public colors: any[] = [];
  customCssCheckBox: any;
  Checkedall: boolean = false;
  Checkedmagnetic: boolean = false;
  CheckedwhatsHot: boolean = false;
  Checkedenrollment: boolean = false;
  Checkedlips: boolean = false;
  Checkedeyes: boolean = false;
  slides: Array<any> = [];
  sortKeys: Array<any> = [];
  selectedCategory: any = { Category: "all", CategoryId: -1 };
  isAllunselect: boolean;
  regularDistribution = 100 / 3 + "%";
  RegionIDForRequest: any;
  selectedCategoryId: any = 'all';
  isSidebarFixed: any = 0;
  storeId:any;
  pageSize = 9;
  currentPage = 1;
  allProducts: any[] = [];
  filteredProductsLength = 0;
  
  // Scrolling banner content - Fun and positive wellness messages
  scrollContent = [
    { phrase: "Feel Energized" },
    { phrase: "Juice Life" },
    { phrase: "Boost Metabolism" },
    { phrase: "Stay Balanced" },
    { phrase: "Rest & Recharge" },
    { phrase: "Transform Your Life" },
    { phrase: "Premium Quality" },
    { phrase: "Science Backed" },
    { phrase: "Results Driven" },
    { phrase: "Natural Ingredients" },
    { phrase: "Made in USA" },
    { phrase: "Feel Energized" },
    { phrase: "Juice Life" },
    { phrase: "Boost Metabolism" },
    { phrase: "Stay Balanced" },
    { phrase: "Rest & Recharge" },
    { phrase: "Transform Your Life" },
    { phrase: "Premium Quality" },
    { phrase: "Science Backed" },
    { phrase: "Results Driven" },
    { phrase: "Natural Ingredients" },
    { phrase: "Made in USA" }
  ];

  constructor(
    private translate: TranslateService,
    private titleService: Title,
    private productService: ProductService,
    public configService: ConfigService,
    public utilityService: UtilityService,
    public itemsListService: ItemsListService,
    public companyService: CompanyService,
    public cart1Service: Cart1Service,
    public router: Router,
    public dialog: MatDialog,
    private loader: LoaderService,
    public userService: UserService,
    private apiService: RestApiService,
    private cdr: ChangeDetectorRef
  ) {

  }

  public OrderQuantityCount: any;
  showNoProductsError: boolean = false;
  showIsLoading: boolean = true;

  ngOnInit() {
    window.scrollTo(0, 0);
    let a = sessionStorage.getItem('selectedCountry');
    
    // Add timeout fallback in case config loading fails
    setTimeout(() => {
      if (this.displayProductList.length === 0) {
        this.getAllProductItems(DefaultRegionID); // Default region ID
      }
    }, 3000);
    
    this.configService.getCommonSetting(a, sessionStorage.getItem('SelectedLanguage')).then(() => {
      this.userService.userServiceModal.selectedCountry = a
      this.RegionIDForRequest = this.companyService.getRegionID(a || this.userService.userServiceModal?.selectedCountry || 'US')
      this.getAllProductItems(this.RegionIDForRequest);
    }).catch(error => {
      this.getAllProductItems(DefaultRegionID); // Fallback to default region
    });

    //somtimes common setting loaded in time then items are called otherwise no items called
    // this.getstoreId();
    this.sortByOrder = this.utilityService.getSortKey()[6];
    this.translate.get("global_Company_Title").subscribe((text: string) => {
      this.titleService.setTitle(
        this.translate.instant("pagetitle_product") + " | " + text
      );
    });

    this.loader.isLoading.subscribe((v) => {
      this.showIsLoading = v;
      if (v == false) {
        this.showNoProductsError = true;
      }
    });
  }
  compareObjects(o1: any, o2: any): boolean {
    return o1.name === o2.name && o1.id === o2.id;
  }

  // sorting type ASC / DESC / A-Z / Z-A etc.
  onChangeSorting($event) {
    this.sortByOrder = $event.value;
  }

  public onPageChanged(event) {
    this.page = event;
    window.scrollTo(0, 0);
  }


  onChange(selectedCategory) {
    this.displayProductList = [];
    this.currentPage = 1;
    this.selectedCategoryId = selectedCategory;
    
    let sourceProducts = [];
    
    if (selectedCategory == 'all') {
      sourceProducts = this.products;
    } else {
      sourceProducts = this.products
        .filter((product) => product.CategoryId === selectedCategory)
        .sort((a, b) => a.Category.localeCompare(b.Category));
    }
    
    // Apply custom homepage ordering to the products
    sourceProducts = this.sortProductsByHomepageOrder(sourceProducts);
    
    this.filteredProductsLength = sourceProducts.length;
    this.displayProductList = sourceProducts;
  }

  mouseEnter(index) {
    if (screen.width > 960) {
      document.getElementById("btn" + index).classList.add("faded-in");
      document.getElementById("btn" + index).classList.remove("faded-out");
      setTimeout(() => {
        document.getElementById("btn" + index).style.opacity = "1";
      }, 590);
    }
  }
  mouseOut(index) {
    if (screen.width > 960) {
      document.getElementById("btn" + index).classList.add("faded-out");
      setTimeout(() => {
        document.getElementById("btn" + index).style.opacity = "0";
      }, 590);
      document.getElementById("btn" + index).classList.remove("faded-in");
    }
  }
  increaseQuantiy(type, item) {
    this.cart1Service.increaseQuantiy(item, type == "autoship", type == "pack");
  }

  // Add product to cart
  addToCart(product: any) {
    // Ensure we're using the correct product data (selected pack if available)
    const productToAdd = product._selectedPack || product;
    
    // Check if product is out of stock
    if (productToAdd?.OutOfStockStatus == 3) {
      return;
    }

    // Add to cart using the cart service
    this.cart1Service.addToCart(
      productToAdd,
      true, // show notification
      '', // custom order code
      false, // isAutoship
      false, // fromDialog
      false, // isPack
      false, // fromApplication
      false, // fromPointbtn
      null, // countFromSharelink
      false, // loyaltyOrder
      null // enrollProducts
    );

    // Store product for sidebar if needed
    localStorage.setItem("params.item", JSON.stringify(productToAdd));
  }

  getAllProductItems(RegionID?) {
    // Get store ID from session storage (set by header component) or use default
    this.storeId = sessionStorage.getItem('selectedStoreId') || REWARDSTORE; // Rewards Store ID - 07E1082984

    // IMPORTANT: Set the store ID in session storage for checkout to use
    // This ensures new customers have the correct store ID during checkout
    sessionStorage.setItem('selectedStoreId', this.storeId);

    this.selectedCategory = { CategoryId: "all" };
    const request = {
      RegionID: RegionID || DefaultRegionID,
      CategoryId: "all",
      StoreID: this.storeId
    };
    
    //main request for api calling
    this.productService.getProductByCategory(request).subscribe({
      next: (products) => {
        this.productService.orders = products.map((item) => {
          item.Price = item.Price || (item.Prices && item.Prices[0] && item.Prices[0].Price);
          return item;
        });

        //filling unique products according to category
        const uniqueRequireProduct = ([] = _.uniqBy(products, (x) => x.CategoryId));

        //selected category data filling
        this.itemsListService.selectedCategories = {};
        if (this.selectedCategory.CategoryId == "all") {
          this.itemsListService.selectedCategories["all"] = true;
        }
        //itemlistservice categorylist data filling
        this.itemsListService.categoryList = _.map(uniqueRequireProduct, (object) => { return _.pick(object, ["CategoryId", "Category"]); });

        //empty product array
        this.products = [];

        const product = (this.allProducts = this.productService.orders);

        product.filter((x) => {
          // Include products with categories OR products that have a valid ProductName
          if (x.Category || (x.ProductName && x.ProductName.trim().length > 0)) {
            // Set a default category for products without categories
            if (!x.Category && x.ProductName) {
              // Special handling for enrollment items
              if (x.ProductName === 'Enroll' || x.ProductName?.toLowerCase().includes('enroll')) {
                x.Category = 'Enrollment';
                x.CategoryId = 'enrollment';
              } else {
                // General products without category
                x.Category = 'General';
                x.CategoryId = 'general';
              }
            }
            this.products.push(x);
          }
        });
        
        //filling products here in the html use to display products
        this.onChange('all');
        
        // Force change detection to ensure pipe is applied
        this.cdr.detectChanges();
        this.itemsListService.type = "order";

        //displaying according to category
        var category;
        this.itemsListService.categoryList.filter((x) => {
          if (x.CategoryId == this.selectedCategory.CategoryId) {
            category = x.Category;
          }
        });
        if (this.selectedCategory.CategoryId == "all") {
          this.itemsListService.getItemsByCategory("all");
        } else {
          this.itemsListService.getItemsByCategory(category);
        }
      },
      error: (error) => {
        console.error('Product loading failed:', error);
        // The ProductService should have already handled fallback to mock data
        // But let's make sure we have some products
        if (this.displayProductList.length === 0) {
          // No products in display list, something went wrong with fallback
        }
      }
    });
    this.env = environment;
  }

  goToShop(id) {
    let prodId = id;
    let proddata = {};

    this.productService.getProduct(prodId).subscribe((product) => {
      proddata = this.product;
      this.product = product ? [product] : [];
      this.productService.selectedOrderItems.filter((x) => {
        if (x.ItemID == this.product[0].ItemID) {
          this.product.Quantity = x.Quantity;
        }
      });

      if (this.product.length) {
        const dialogRef = this.dialog.open(DialogforproductComponent, {
          data: {
            product: this.product,
            productList: this.products,
          },
          maxHeight: "600px",
        });
        dialogRef.afterClosed().subscribe((dialogresult) => {
          if (true) {
            this.router.navigate(["/shop"]);
            this.itemsListService.getItemsByCategory(this.itemsListService.selectedCategories);
          }
        });
      }
      this.OrderQuantityCount =
        product && product.Quantity ? product.Quantity : 1;
    });
  }

  browsefunc(CategoryId) {
    this.selectedCategory = { CategoryId: CategoryId };

    this.productService.orders = this.products.map((item) => {
      item.Price =
        item.Price ||
        (item.Prices && item.Prices[0] && item.Prices[0].Price);
      return item;
    });
    const uniqueRequireProduct = ([] = _.uniqBy(
      this.products,
      (x) => x.CategoryId
    ));

    this.itemsListService.selectedCategories = {};


    if (this.selectedCategory.CategoryId == "all") {
      this.itemsListService.selectedCategories["all"] = true;
    }

    this.itemsListService.categoryList = _.map(
      uniqueRequireProduct,
      (object) => {
        return _.pick(object, ["CategoryId", "Category"]);
      }
    );

    this.products = [];
    const product = (this.itemsListService.products =
      this.productService.orders);
    product.filter((x) => {
      // Include products with categories OR products that have a valid ProductName
      if (x.Category || (x.ProductName && x.ProductName.trim().length > 0)) {
        // Set a default category for products without categories
        if (!x.Category && x.ProductName) {
          // Special handling for enrollment items
          if (x.ProductName === 'Enroll' || x.ProductName?.toLowerCase().includes('enroll')) {
            x.Category = 'Enrollment';
            x.CategoryId = 'enrollment';
          } else {
            // General products without category
            x.Category = 'General';
            x.CategoryId = 'general';
          }
        }
        this.products.push(x);
      }
    });
    this.itemsListService.products = this.products;
    this.itemsListService.type = "order";
    var category;
    this.itemsListService.categoryList.filter((x) => {
      if (x.CategoryId == this.selectedCategory.CategoryId) {
        category = x.Category;
      }
    });
    if (this.selectedCategory.CategoryId == "all") {
      this.itemsListService.getItemsByCategory("all");
    } else {
      this.itemsListService.getItemsByCategory(category);
    }


    this.slides = this.configService.localSettings.Product.PrimaryBanner;

    this.sortKeys = this.utilityService.getSortKey();
    this.env = environment;
  }
  leftPosition = '0%';
  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    const width = event.target.innerWidth;
    if (width < 992) {
      this.leftPosition = '0%';
    }
    else if (width > 992 && width < 1400) {
      this.leftPosition = '0%';
    } else if (width > 1401 && width < 1599) {
      this.leftPosition = '4.2%';
    }else if(width > 1600 && width < 1799){
      this.leftPosition = '7.2%';

    }
    else if (width > 1800 && width<2000) {
      this.leftPosition = '16%';
    }else{
      this.leftPosition = '19%';

    }
    // if (width > 1920) {
    //   this.leftPosition = '18%';
    // } else if (width > 1600) {
    //   this.leftPosition = '10%';
    // } else if (width > 1440) {
    //   //this.leftPosition = '7%';
    // }  else if (width > 1024) {
    //   this.leftPosition = '2%';
    // }
    // else {
    //   this.leftPosition = '3.6%';
    // }
  }
  navigateproductDetail(data: any) {
    // Ensure we're using the correct product data for navigation
    const productToNavigate = data._selectedPack || data;
    const formattedProductUrl = `${productToNavigate.ProductName.replace(/\s+/g, '-').toLowerCase()}-id${productToNavigate.ItemID}`;
    // this.router.navigate([`/product/${formattedProductUrl}`]);
    this.router.navigate(['/product'], { queryParams: { id: formattedProductUrl } });
  }

  // Method to handle pack selection change
  onPackSelectionChange(product: any, selectedPack: any) {
    if (product._isGrouped) {
      product._selectedPack = selectedPack;
      // Don't modify the original product object, just update the selected pack reference
    }
  }

  // Method to get pack size display name
  getPackDisplayName(product: any): string {
    if (!product?.ProductName) return '';
    
    const packMatch = product.ProductName.match(/(\d+)pk/i);
    if (packMatch) {
      return `${packMatch[1]} Pack`;
    }
    
    return 'Single';
  }

  // @ViewChild('CategoryBoxScroll') CategoryBoxScroll!: ElementRef<HTMLDivElement>;
  // isOverflow = false;
  // checkOverflow(): void {
  //   const element = this.CategoryBoxScroll.nativeElement;
  //   const maxHeight = 30 * 16;
  //   this.isOverflow = element.scrollHeight > maxHeight;
  // }
  // onscreenchange(): void {
  //   this.checkOverflow();
  // }

  // Load More Products
  loadMoreProducts() {
    this.currentPage++;
    const startIndex = (this.currentPage - 1) * this.pageSize;
  
    let sourceProducts = [];
  
    if (this.selectedCategoryId === "all") {
      sourceProducts = this.products;
    } else {
      sourceProducts = this.products.filter(
        (product) => product.CategoryId === this.selectedCategoryId
      );
    }
    
    // Apply custom homepage ordering to maintain consistency
    sourceProducts = this.sortProductsByHomepageOrder(sourceProducts);
    
    this.filteredProductsLength = sourceProducts.length;
    const newProducts = sourceProducts.slice(startIndex, startIndex + this.pageSize);
  
    if (newProducts.length) {
      this.displayProductList = [...this.displayProductList, ...newProducts];
    }
  }

  // Check if user is logged in
  isLoggedIn(): boolean {
    return this.apiService.loginStatus.value || false;
  }

  // Search click handler
  onSearchClick(): void {
    // Search functionality is handled by the pipe in template
  }

  // Helper method to get product variant based on index
  getProductVariant(index: number): string {
    const variants = ['green', 'yellow', 'orange'];
    return variants[index % variants.length];
  }

  // Custom ordering method to match homepage product order
  sortProductsByHomepageOrder(products: any[]): any[] {
    if (!products || products.length === 0) {
      return products;
    }

    // Define the homepage product order by name/keywords
    const homepageOrder = [
      'metabology matrix',
      'metabology ω3',
      'metabology lean',
      'photonic activator',
      'metabology am',
      'metabology pm',
      'metabology am/pm',
      'rose gold elixir',
      'charcoal cleanser',
      'beauty collection'
    ];

    // Create a map for quick lookup
    const orderMap = new Map<string, number>();
    homepageOrder.forEach((name, index) => {
      orderMap.set(name.toLowerCase(), index);
    });

    // Sort products based on homepage order
    return products.sort((a, b) => {
      const aName = (a.ProductName || '').toLowerCase();
      const bName = (b.ProductName || '').toLowerCase();
      
      // Find the best match for each product
      const aOrder = this.findBestMatch(aName, orderMap);
      const bOrder = this.findBestMatch(bName, orderMap);
      
      // If both products are in the homepage order, sort by that order
      if (aOrder !== -1 && bOrder !== -1) {
        return aOrder - bOrder;
      }
      
      // If only one is in homepage order, prioritize it
      if (aOrder !== -1) return -1;
      if (bOrder !== -1) return 1;
      
      // If neither is in homepage order, keep original order
      return 0;
    });
  }

  // Helper method to find the best match for a product name
  private findBestMatch(productName: string, orderMap: Map<string, number>): number {
    // Try exact match first
    if (orderMap.has(productName)) {
      return orderMap.get(productName)!;
    }
    
    // Try partial matches
    for (const [homepageName, order] of orderMap) {
      if (productName.includes(homepageName) || homepageName.includes(productName)) {
        return order;
      }
    }
    
    // Try matching key terms
    const keyTerms = {
      'matrix': 0,
      'ω3': 1,
      'omega': 1,
      'lean': 2,
      'photonic': 3,
      'activator': 3,
      'am': 4,
      'pm': 5,
      'rose gold': 7,
      'elixir': 7,
      'charcoal': 8,
      'cleanser': 8,
      'beauty collection': 9
    };
    
    for (const [term, order] of Object.entries(keyTerms)) {
      if (productName.includes(term)) {
        return order;
      }
    }
    
    return -1; // Not found in homepage order
  }

  // Helper method to get variant color for the round button
  getVariantColor(variant: string): string {
    const variantColors = {
      green: '#677240',
      yellow: '#F09F53',
      orange: '#F18021'
    };
    return variantColors[variant as keyof typeof variantColors] || '#677240';
  }

  // Helper method to clean HTML from descriptions
  cleanDescription(description: string): string {
    if (!description) return 'Premium wellness product designed to enhance your daily routine and well-being.';
    
    // Remove HTML tags and clean up the text
    let cleanText = description
      .replace(/<[^>]*>/g, '') // Remove all HTML tags
      .replace(/&nbsp;/g, ' ') // Replace &nbsp; with spaces
      .replace(/\s+/g, ' ') // Replace multiple spaces with single space
      .trim(); // Remove leading/trailing whitespace
    
    // Extract just the first sentence or two for better readability (like homepage)
    const sentences = cleanText.split('.').filter(s => s.trim().length > 0);
    if (sentences.length > 0) {
      // Take first sentence and if it's short, add the second one
      let result = sentences[0].trim();
      if (result.length < 80 && sentences.length > 1) {
        result += '. ' + sentences[1].trim();
      }
      // Ensure it ends with a period
      if (!result.endsWith('.')) {
        result += '.';
      }
      return result;
    }
    
    // Fallback to truncated version
    if (cleanText.length > 100) {
      return cleanText.substring(0, 100) + '...';
    }
    
    return cleanText || 'Premium wellness product designed to enhance your daily routine and well-being.';
  }

  // Format product name to match homepage style
  formatProductName(productName: string): string {
    if (!productName) return 'Product';
    
    // Just return the original product name as-is
    return productName;
  }

  // Format price to match homepage style
  formatPrice(price: number): string {
    if (!price) return '$0.00';
    
    // Format as currency like homepage
    return `$${price.toFixed(2)}`;
  }

  // Format RV to match homepage style
  formatRV(rv: number): string {
    if (!rv) return '';
    
    // Format as "X RV" like homepage
    return `${rv} RV`;
  }

  // Format description to match homepage style
  formatDescription(product: any): string {
    // Get the product name for matching
    const productName = product.ProductName?.toLowerCase() || '';
    
    // Use specific, short descriptions like homepage
    if (productName.includes('metabology')) {
      if (productName.includes('am')) {
        return 'Metabology AM is here to give you that morning kickstart, helping you take on the day with steady energy, focus, and metabolic power.';
      } else if (productName.includes('pm')) {
        return 'Metabology PM is here to help you settle into a restful night while ensuring your metabolism gets the support it needs.';
      } else if (productName.includes('lean')) {
        return 'Metabology Lean gives powerful thermogenic support to achieve the lean, healthy physique you\'ve been working toward.';
      } else if (productName.includes('omega') || productName.includes('ω3')) {
        return 'Metabology Ω3 provides the omega-3 boost your body needs for a productive metabolism, heart health, and clear thinking, day after day.';
      } else if (productName.includes('matrix')) {
        return 'Why settle for just one? This powerhouse set is designed to keep your metabolism running smoothly 24/7.';
      } else {
        return 'Metabology products are designed to support your metabolism and energy levels throughout the day.';
      }
    } else if (productName.includes('photonic')) {
      return 'Metabology Photonic Activator optimizes your wellness routine to energize, recharge, and support your metabolism all day long.';
    } else if (productName.includes('rose') || productName.includes('elixir')) {
      return 'Rose Gold Elixir is here to elevate your beauty ritual, delivering radiance, rejuvenation, and restoration with each application.';
    } else if (productName.includes('charcoal') || productName.includes('cleanser')) {
      return 'Purifying Charcoal Cleanser is a gentle yet powerful formula to transform your cleansing routine into a refreshing ritual of renewal.';
    }
    
    // For other products, use a very short, clean description
    if (product.Description) {
      let cleanText = this.cleanDescription(product.Description);
      // Limit to first sentence only and max 80 characters
      const firstSentence = cleanText.split('.')[0];
      if (firstSentence && firstSentence.length <= 80) {
        return firstSentence + '.';
      } else if (firstSentence) {
        return firstSentence.substring(0, 77) + '...';
      }
    }
    
    return 'Premium wellness product designed to enhance your daily routine and well-being.';
  }

  getCategoryCount(categoryId: string): number {
    if (!this.allProducts) return 0;
    
    // First filter by search text (same logic as productSearch pipe)
    let searchFiltered = this.allProducts;
    if (this.productSearchText) {
      searchFiltered = this.allProducts.filter(item => 
        (item.ProductName?.toLowerCase().indexOf(this.productSearchText.toLowerCase()) > -1) ||
        (item.Description?.toLowerCase().indexOf(this.productSearchText.toLowerCase()) > -1) ||
        (item.SKU?.toLowerCase().indexOf(this.productSearchText.toLowerCase()) > -1)
      );
    }
    
    // Then filter by category
    const categoryFiltered = searchFiltered.filter(p => p.CategoryId === categoryId);
    return categoryFiltered.length;
  }
}
